import type React from 'react';

import { FormField, Label, Select } from '@zillow/constellation-10';

import type { Section } from '../../../models/index';
import { MAXIMUM_NUMBER_OF_OCCUPANTS } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const MAX_OCCUPANTS = 13;

// Generate options from 1 to max occupants
const occupantsOptions = Array.from({ length: MAX_OCCUPANTS }, (_, i) => {
  const value = i + 1;
  return { value: String(value), label: `${value} occupant${value === 1 ? '' : 's'}` };
});

function MaximumNumberOfOccupants({ section, setSectionValues }: Props) {
  function onMaximumOccupancyChange(event: React.ChangeEvent<HTMLSelectElement>): void {
    setSectionValues({
      [MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS]: Number(event.target.value),
    });
  }
  const maximumOccupants = Number(
    section.getFieldValue(MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS),
  );

  return (
    <FormField
      required
      label={<Label>What is the total max occupancy permitted?</Label>}
      control={
        <Select value={String(maximumOccupants)} onChange={onMaximumOccupancyChange}>
          {occupantsOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      }
    />
  );
}

MaximumNumberOfOccupants.description =
  'Allow Irene to set the maximum amount of occupants (tenants + additional occupants).';

export default MaximumNumberOfOccupants;
